export const Types = {
    GET_SHIFTS: "GET_SHIFTS",
    SET_SHIFTS: "SET_SHIFTS"
};

export const getShifts = (payload) => ({
    type: Types.GET_SHIFTS,
    payload: payload,
});

export const setShifts = (payload) => ({
    type: Types.SET_SHIFTS,
    payload: payload,
});